import { render, staticRenderFns } from "./TraceabilityAlert.vue?vue&type=template&id=091d6dfa"
import script from "./TraceabilityAlert.vue?vue&type=script&lang=js"
export * from "./TraceabilityAlert.vue?vue&type=script&lang=js"
import style0 from "./TraceabilityAlert.vue?vue&type=style&index=0&id=091d6dfa&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports